/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { setMediaKitData } from '../../../redux/MediakitRedux';
import { getFolder } from '../../actions/media_actions';
import { useContext, useEffect } from 'react';
import { MediaContext } from '..';
import { API } from 'aws-amplify';
import CustomTempGetMyFolderQuery from './CustomTempGetMyFolderQuery';

/* eslint-disable no-console */
const useGetMyFolders = ({ debounceSearchTerm = '' }) =>
{
	const dispatch = useDispatch();
	const { mediaState, setMediaState } = useContext(MediaContext);
	const { folderData, employeeData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const { tab } = useContext(MediaContext);
	const query = CustomTempGetMyFolderQuery(debounceSearchTerm);

	const getCount = async () =>
	{
		query.count = true;

		try
		{
			const res = await getFolder(query, 'folders');

			if (res?.status)
			{
				setMediaState({ type: 'setCount', payload: { [(tab === 2 ? 'employee' : 'myFolders')]: res?.count } });
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	let folderPromise:any = '';

	const setEmployeeData = (res) =>
	{
		return setMediaKitData({
			employeeData : mediaState?.page === 0 ? res?.data : [ ...employeeData, ...res.data ]
		});
	};

	const setFolderData = (res) =>
	{
		return setMediaKitData({
			folderData : mediaState?.page > 0 ? [ ...folderData, ...res.data ] : res.data
		});
	};

	const handleSuccessResponse = (res) =>
	{
		if (mediaState?.page === 0)
		{
			if (res?.data?.length >= 12)
			{
				getCount();
			}
			else
			{
				setMediaState({
					type    : 'setCount',
					payload : {
						[(tab === 2 ? 'employee' : 'myFolders')] : res?.data?.length
					}
				});
			}
		}

		const action = tab === 2 ? setEmployeeData(res) : setFolderData(res);

		dispatch(action);
		setMediaState({ type: 'updateReducer', payload: { loading: false } });
	};

	const shouldFetchFolderData = () =>
	{
		return (
			mediaState?.page === 0 &&
		(folderData?.length === 0 ||
			folderData[0]?.parent !== '' ||
			debounceSearchTerm)
		);
	};

	const getFoldersData = async (filter = mediaState?.filter) =>
	{
		const newArr = filter ? filter.split(',') : [];
		const updateArr = newArr.length > 0 ? newArr.map((item) => Number(item)) : [];

		if (filter && filter !== '1,2,3,4,5')
		{
			query.mediaType = JSON.stringify(updateArr);
		}

		const shouldFetchData = shouldFetchFolderData();

		if (shouldFetchData)
		{
			setMediaState({ type: 'updateReducer', payload: { loading: true } });
		}

		if (filter && filter !== '1,2,3,4,5') { query.mediaType = JSON.stringify(updateArr); }

		mediaState?.page === 0 && (folderData?.length === 0 || folderData[0]?.parent !== '' || debounceSearchTerm) && setMediaState({ type: 'updateReducer', payload: { loading: true } });
		try
		{
			let res = { status: true, data: [] };

			if (filter.length !== 0) // as per the QA requirement-#I4022
			{
				folderPromise = getFolder(query, 'folders');

				res = await folderPromise;
			}

			if (res?.status)
			{
				handleSuccessResponse(res);
			}
		}
		catch (err)
		{
			console.log(err);
			setMediaState({ type: 'updateReducer', payload: { loading: false } });
		}
	};

	useEffect(() =>
	{
		return () =>
		{
			API.cancel(folderPromise, 'cancelled by user');
		};
	}, [ tab, mediaState?.sort ]);

	return getFoldersData;
};

export default useGetMyFolders;